/**
 * Created by agengmaulana on 4/28/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'

import Comment_Date from '../comment_date/comment_date'

export default class Comment_Username extends React.Component{

    constructor(props) {
        super(props);
        this.state={
            mb10: this.props.mb10,
        }
    }

    render(){
        let verified = "";
        if (typeof this.props.verified_user !== 'undefined') {
            verified = this.props.verified_user != true ? '' : <i className="dk_icon dk_icon-circle dk_check verified"></i>
        }

        let data = this.state.mb10 == 'false' ? '' : styles.cmt_mb10
        return(
            <div className={styles.cmt_dk_name+' '+data}>
                {this.props.nickname} {verified}<br/>
                { this.props.date == 0 ? '': <Comment_Date time={this.props.create_date}/> }

            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./static/src/component/comment_username/comment_username.js